import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  accordions: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
  },
}));

export default useStyles;
